import { render } from "./Maintenance.vue?vue&type=template&id=045bf9e6&scoped=true"
import script from "./Maintenance.vue?vue&type=script&lang=js"
export * from "./Maintenance.vue?vue&type=script&lang=js"

import "./Maintenance.vue?vue&type=style&index=0&id=045bf9e6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045bf9e6"]])

export default __exports__